import React, { FC } from 'react';

import { BlogTagInterface } from '@/src/assets/interfaces/blogTagInterface';

import styles from './BlogPostTag.module.scss';

interface BlogPostTagProps {
    tag: BlogTagInterface;
}

const BlogPostTag: FC<BlogPostTagProps> = ({ tag }) => {
    return (
        <a href={`/blog/tag/${tag.slug}`} className={styles.postTag}>
            {tag.title}
        </a>
    );
};

export { BlogPostTag };
